/**
 * Slot labels manifest — Phase 8.0 (Lite).
 *
 * Each composite slot lists the named sub-labels admins can rename via
 * Form Designer. Format:
 *
 *   {
 *     "<slot_key>": [
 *       { name: "<sub_key>", label: "<default label>" },
 *       …
 *     ],
 *     …
 *   }
 *
 * The slot component reads each sub-label via the `useSlotLabel(slotKey)`
 * hook: `t("site", "Site")` → returns the override if any, else the
 * manifest default, else the inline fallback.
 *
 * Storage: lbs_booking_field_overrides with scope='slot_label' and
 *   field_key=`${slot_key}::${sub_key}` (e.g. "schedule.header::site").
 *
 * Adding more slots: append entries here, edit the slot component to
 * call `t(name, default)`, done. No schema change required.
 */
export const SLOT_LABELS = {
  "driver.picker": [
    { name: "tba_checkbox_label", label: "Driver TBA — assign later" },
    { name: "tba_warning_text",   label: "Booking will show as outstanding · gate check-in and admin approval blocked until real driver assigned" },
  ],
  "schedule.header": [
    { name: "site",         label: "Site" },
    { name: "bay",          label: "Bay" },
    { name: "direction",    label: "Direction" },
    { name: "reservation",  label: "Reservation type" },
    { name: "date",         label: "Date" },
    { name: "start_time",   label: "Start time" },
    { name: "end_time",     label: "End time" },
  ],
  "vehicle.mass-heading": [
    { name: "title", label: "Mass limits (kg)" },
  ],
  "restraint.counts-heading": [
    { name: "title", label: "Restraint counts" },
  ],
  "restraint.pallets-heading": [
    { name: "title",    label: "Pallets" },
    { name: "subtitle", label: "FLD confirms these on QA" },
  ],
  "compliance.cold-chain": [
    { name: "yn_question",        label: "Cold-chain load?" },
    { name: "subchoice_question", label: "Chill or frozen?" },
  ],
  "qa.temperatures": [
    { name: "section_title",   label: "Temperatures (°C)" },
    { name: "between_cartons", label: "Pallet temp between cartons" },
    { name: "sample_1",        label: "Sample pallet #1 temp" },
    { name: "sample_2",        label: "Sample pallet #2 temp" },
  ],
  "qa.damage": [
    { name: "section_title", label: "Damage (FLD entry)" },
    { name: "pallets",       label: "Damage — pallets" },
    { name: "products",      label: "Damage — products" },
    { name: "notes",         label: "Damage notes" },
  ],
  "qa.pallet-flow": [
    { name: "section_title", label: "Pallet flow (actuals + account)" },
    { name: "actual_in",     label: "Actual pallets IN" },
    { name: "actual_out",    label: "Actual pallets OUT" },
    { name: "account_in",    label: "Pallet account IN (sender brand acc.)" },
    { name: "account_out",   label: "Pallet account OUT (receiver brand acc.)" },
    { name: "docket",        label: "Docket / transfer number" },
  ],
  "qa.trailer-weights": [
    { name: "section_title", label: "Trailer weights (tonnes)" },
    { name: "load",          label: "Load (with pallets)" },
    { name: "trailer_1",     label: "Trailer #1" },
    { name: "trailer_2",     label: "Trailer #2" },
  ],
  "qa.fld-only": [
    { name: "section_title", label: "FLD-only entry" },
    { name: "fld_assignment", label: "Forklift driver assignment" },
    { name: "temp_set",      label: "Temp set (at load)?" },
  ],
};
